// React Imports
import React, { createContext } from 'react'

// Custom Hook Imports
import UseNewListingForm from '../hooks/UseNewListingForm'

// Creates the context to be used with the new listing form
export const NewListingFormContext = createContext();

function NewListingFormProvider({ children, startPlanOption}) {
    const {
        showNewListingForm,
        isSubmitted,
        isProcessing,
        isSuccessfull,
        errors,
        apiResponseMessage,
        showSuccess,
        showErrors,
        showLoading,
        newListing,
        handleChange,
        handlePlanChange,
        handleListingTypeChange,
        handleSubmit,
        handleFileChange,
    } = UseNewListingForm(startPlanOption);

    return (
        <NewListingFormContext.Provider value={{
            showNewListingForm,
            isSubmitted,
            isProcessing,
            isSuccessfull,
            errors,
            apiResponseMessage,
            showSuccess,
            showErrors,
            showLoading,
            newListing,
            handleChange,
            handlePlanChange,
            handleListingTypeChange,
            handleSubmit,
            handleFileChange,
        }}>
            {children}
        </NewListingFormContext.Provider>
    )
}

export { NewListingFormProvider }